const toggleVisibility = (el, show, visibilityClass = 'flex') => {
  if (!el) return;
  el.classList.toggle('hidden', !show);
  el.classList.toggle(visibilityClass, show);
};

export default toggleVisibility;
